import React, { useCallback, useEffect, useRef, useState } from "react";
import OrderDetailRow from "../../components/form/OrderDetailRow";
import { Alert, Button, Divider, Modal, Radio, SelectProps } from "antd";
import api from "../../utils/axios";
import {
	PrinterOutlined,
	FormOutlined,
	DeleteOutlined,
	CheckOutlined,
	CameraOutlined,
} from "@ant-design/icons";
import OrderHistory from "../../components/OrderHistory";
import DefaultSelect from "../../components/form/DefaultSelect";
import { toast } from "react-toastify";
import "./OrderDetails.css";
import { useNavigate } from "react-router";
import Buttons from "../../components/form/Buttons";
import { getUserRoleFromToken } from "../../utils/Auth";
import { fetchAllUsers } from "../../lib/UserApi";
import { fetchZones, getConfigurationValue } from "../../lib/OptionListApi";
import { OrderUpdateType } from "../../types/OrderUpdateType";
import { orderStatuses, userRoles } from "../../types/enums";
import useLang from "../../hooks/useLang";
import OrderPriceChangeRequest from "../../components/OrderPriceChangeRequest";
import SettlementOrderHistory from "../../components/SettlementOrderHistory";
import { hasAccess } from "../../lib/MenuValidation";
import PlaceAutocomplete from "../../components/GoogleMaps/PlaceAutocomplete";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { CONFIG } from "../../config";
import AddressSelect from "../../components/form/AddressSelect";
import DefaultInput from "../../components/form/DefaultInput";
import { MenuAccess } from "../../utils/menuOptions";

interface IOrderHistory {
	statusId: number;
	orderId: number;
	userId: number;
	statusDate: string;
	statusChangeComment?: string;
	userRoleDescription?: string;
	phone?: string;
	userName?: string;
}
interface Zone {
	id: number;
	description: string;
	levelId: number;
	parentId: any;
}
interface SortingMachinePhoto {
	objectKey: string;
	base64Data: string;
	sizeBytes: number;
	cameraId: number;
}
const statusOptions = [
	{ value: 3, label: "Grumbulluar" },
	{ value: 4, label: "Në depo" },
	{ value: 5, label: "Në transport" },
	{ value: 6, label: "Dorëzuar" },
	{ value: 7, label: "Refuzuar" },
	{ value: 8, label: "Në pritje" },
	{ value: 9, label: "Në pritje për tërheqje" },
	{ value: 10, label: "Kthyer" },
	//{ value: 11, label: "Ndërrim" },
	{ value: 13, label: "Ne Depon për kthim" },
	{ value: 14, label: "Ne Transport Internacional" },
];

const macedonianStatusTranslations: any = {
	3: "Собрано",
	4: "Во магацин",
	5: "Во транспорт",
	6: "Испорачано",
	7: "Одбиено",
	8: "Во очекување",
	9: "На чекање за повлекување",
	10: "Вратено",
	13: "Во магацин за враќање",
	14: "Во меѓународен транспорт",
};

const specialReturnedStatusOptions = [
	{ value: orderStatuses.IN_STORAGE, label: "Në depo" },
];

const nonEditableStatusIds = [
	orderStatuses.DELIVERED,
	orderStatuses.REJECTED,
	orderStatuses.AWAITING_WITHDRAWL,
	orderStatuses.RETURNED,
	orderStatuses.EXCHANGE,
	orderStatuses.REDIRECTED,
	orderStatuses.RETURN_STORAGE,
];

const nonEditableStatusIdsClient = [
	orderStatuses.PICKED_UP,
	orderStatuses.IN_STORAGE,
	orderStatuses.TRANSPORTING,
	orderStatuses.DELIVERED,
	orderStatuses.REJECTED,
	orderStatuses.PENDING,
	orderStatuses.AWAITING_WITHDRAWL,
	orderStatuses.RETURNED,
	orderStatuses.EXCHANGE,
	orderStatuses.REDIRECTED,
	orderStatuses.RETURN_STORAGE,
	orderStatuses.INTERNATIONAL_TRANSPORTING,
	orderStatuses.REFUNDED,
	orderStatuses.CANCELLED,
];

const statusAccessMap: Record<number, MenuAccess> = {
	3: "ORDER_STATUS_CHANGE_PICKED_IP_ACCESS",
	4: "ORDER_STATUS_CHANGE_IN_STORAGE_ACCESS",
	5: "ORDER_STATUS_CHANGE_TRANSPORTING_ACCESS",
	6: "ORDER_STATUS_CHANGE_DELIVERED_ACCESS",
	7: "ORDER_STATUS_CHANGE_REJECTED_ACCESS",
	8: "ORDER_STATUS_CHANGE_PENDING_ACCESS",
	9: "ORDER_STATUS_CHANGE_AWAITING_WITHDRAWL_ACCESS",
	10: "ORDER_STATUS_CHANGE_RETURNED_ACCESS",
	13: "ORDER_STATUS_CHANGE_RETURN_STORAGE_ACCESS",
	14: "ORDER_STATUS_CHANGE_INTL_TRANSPORTING_ACCESS",
};
const OrderDetails = () => {
	const [orderDetilsData, setOrderDetilsData] = useState<any>([]);
	const [openStatusChangeModal, setOpenStatusChangeModal] =
		useState<boolean>(false);
	const [open, setOpen] = useState<boolean>(false);
	const [
		openChangeStatusToPreviousModal,
		setOpenChangeStatusToPreviousModal,
	] = useState<boolean>(false);
	const [orderHistory, setOrderHistory] = useState<IOrderHistory[]>([]);
	const [settlementOrderHistory, setSettlementOrderHistory] = useState<
		IOrderHistory[]
	>([]);
	const [selectedStatus, setSelectedStatus] = useState<number | null>(null);
	const [selectedUser, setSelectedUser] = useState<number | null>(null);
	const [userOptions, setUserOptions] = useState<any>([]);
	const [isAdmin, setIsAdmin] = useState<boolean>(false);
	const [isClient, setIsClient] = useState<boolean>(false);
	const [userRole, setUserRole] = useState<any>();
	const [allUsers, setAllUsers] = useState<any>();

	const [refId, setRefId] = useState<string>("");
	const [orderDescription, setOrderDescription] = useState<string>("");
	const [packageDescription, setPackageDescription] = useState<string>("");
	const [deliveryInstructions, setDeliveryInstructions] =
		useState<string>("");
	const [openable, setOpenable] = useState<boolean>(false);
	const [fragile, setFragile] = useState<boolean>(false);
	const [declared, setDeclared] = useState<boolean>(false);
	const [allowEdit, setAllowEdit] = useState<boolean>(false);
	const [allowEditTransportPrice, setAllowEditTransportPrice] =
		useState<boolean>(false);
	const [allowEditSellerDescription, setAllowEditSellerDescription] =
		useState<boolean>(false);
	const [warehouseManager, setWarehouseManager] = useState<boolean>();
	const [width, setWidth] = useState<string | null>();
	const [length, setLength] = useState<string | null>();
	const [height, setHeight] = useState<string | null>();
	const [weight, setWeight] = useState<string | null>();
	const [buyerFirstName, setBuyerFirstName] = useState<string | null>();
	const [buyerLastName, setBuyerLastName] = useState<string | null>();
	const [buyerPhoneNo, setBuyerPhoneNo] = useState<string>();
	const [initialBuyerPhoneNo, setInitialBuyerPhoneNo] = useState<string>();
	const [buyerAddress, setBuyerAddress] = useState<string | null>();
	const [buyerAddressDetails, setBuyerAddressDetails] = useState<
		string | null
	>();
	const [selectedCountry, setSelectedCountry] = useState<any>();
	const [selectedCity, setSelectedCity] = useState<any>();
	const [zones, setZones] = useState<Zone[]>([]);
	const [countryOptions, setCountryOptions] = useState<any>();
	const [cityOptions, setCityOptions] = useState<any>();
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [transportPrice, setTransportPrice] = useState<any>();
	const [orderPrice, setOderPrice] = useState<any>();
	const [defaultSystemCountryId, setDefaultSystemCountryId] =
		useState<string>("");
	const [phonePrefix, setPhonePrefix] = useState<string>("");
	const [allowOrderPriceEditing, setAllowOrderPriceEditing] =
		useState<boolean>(false);
	const [buyersList, setBuyersList] = useState<any[]>([]);
	const [isExistingPhoneNumberVisible, setIsExistingPhoneNumberVisible] =
		useState<boolean>(false);
	const { strings } = useLang("orderDetails");

	// const location = useLocation();
	// const orderId = location.state;
	const [lastValidWeight, setLastValidWeight] = useState<string | null>(null);
	const [lastValidHeight, setLastValidHeight] = useState<string | null>(null);
	const [lastValidLength, setLastValidLength] = useState<string | null>(null);
	const [lastValidWidth, setLastValidWidth] = useState<string | null>(null);
	const [lastValidOrderPrice, setLastValidOrderPrice] = useState<
		string | null
	>(null);
	const [lastValidTransportPrice, setLastValidTransportPrice] = useState<
		string | null
	>(null);
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();
	const [sectionId, setSectionId] = useState<number | null>(0);
	const [sellerDescription, setSellerDescription] = useState<string | null>(
		""
	);
	const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
	const [selectedFormat, setSelectedFormat] = useState("100x60");
	const [transportPriceChangeComment, setTransportPriceChangeComment] =
		useState<string>("");
	const [openTransportPriceCommentModal, setOpenTransportPriceCommentModal] =
		useState<boolean>(false);
	const [deliveryCode, setDeliveryCode] = useState<string>("");
	const [requiresDeliveryCode, setRequiresDeliveryCode] =
		useState<boolean>(false);
	const [sortingMachinePhotos, setSortingMachinePhotos] = useState<
		SortingMachinePhoto[]
	>([]);
	const [isSortingMachineModalOpen, setIsSortingMachineModalOpen] =
		useState<boolean>(false);
	const [isLoadingSortingMachinePhotos, setIsLoadingSortingMachinePhotos] =
		useState<boolean>(false);
	const urlParams = new URLSearchParams(window.location.search);
	const orderId = urlParams.get("id");

	const navigate = useNavigate();

	const canUpdateDetails = hasAccess("UPDATE_ORDER_DETAILS_ACCESS");
	const canUpdateOrderDimensions = hasAccess("UPDATE_ORDER_DIMENSION_ACCESS");
	const canChangeOrderValue = hasAccess("ORDER_VALUE_CHANGE_ACCESS");
	const canChangeOrderStatus = hasAccess("ORDER_STATUS_CHANGE_ACCESS");
	const canChangeRefuseOrAwaitOrderStatus = hasAccess(
		"ORDER_AWAIT_OR_REFUSAL_STATUS_CHANGE_ACCESS"
	);
	const hasAccessToA4 = hasAccess("A4_TICKETS_ACCESS");
	const hasAccessToHarleyTickets = hasAccess("HARLEY_TICKETS_ACCESS");
	const hasAccessToSellers = hasAccess("ORDER_DETAILS_SELLER_ACCESS");
	const hasAccessToDeliveryCode = hasAccess("DELIVERY_CODE_ACCESS");
	const hasAccessToIdentificationNo = hasAccess("IDENTIFICATION_NO_ACCESS");
	const accessToOrderPrice = hasAccess("ORDER_DETAILS_ORDER_PRICE_ACCESS");
	const accessToOrderTransportPrice = hasAccess(
		"ORDER_DETAILS_ORDER_TRANSPORT_PRICE_ACCESS"
	);
	const accessToOrderRealPrice = hasAccess(
		"ORDER_DETAILS_ORDER_REAL_PRICE_ACCESS"
	);
	const accessToOrderRealSeller = hasAccess(
		"ORDER_DETAILS_ORDER_REAL_SELLER_ACCESS"
	);
	const accessToSaleProfit = hasAccess("ORDER_DETAILS_SALE_PROFIT_ACCESS");
	const accessToSettlementHistory = hasAccess(
		"ORDER_DETAILS_SETTLEMENT_ACCESS"
	);
	const accessToOrderDimensions = hasAccess(
		"ORDER_DETAILS_DIMENSIONS_ACCESS"
	);
	const noAccessToInternationalOrderPrice = hasAccess(
		"HIDE_INTERNATIONAL_ORDERS_PRICE_ACCESS"
	);
	const hasReturnedToStorageAccess = hasAccess(
		"ORDER_STATUS_CHANGE_RETURNED_TO_STORAGE_ACCESS"
	);

	var sellersWithInternationalOrderPrice = [1, 2, 3];

	const currentLang = useSelector(
		(state: RootState) => state.langReducer.lang
	);

	const isInternationalOrder =
		(orderDetilsData?.countryId !== undefined &&
			defaultSystemCountryId !== "" &&
			orderDetilsData?.countryId !== parseInt(defaultSystemCountryId)) ||
		(orderDetilsData?.internationalStatusId !== null &&
			orderDetilsData?.internationalStatusId !== undefined &&
			orderDetilsData?.internationalStatusId !== 0);

	const canReopenReturnedOrderToStorage =
		hasReturnedToStorageAccess &&
		orderDetilsData?.statusId === orderStatuses.RETURNED &&
		!isInternationalOrder;

	const allowedStatusOptions = (
		canReopenReturnedOrderToStorage
			? specialReturnedStatusOptions
			: statusOptions
	).filter((opt) =>
		canReopenReturnedOrderToStorage
			? specialReturnedStatusOptions.some(
					(specialOption) => specialOption.value === opt.value
			  )
			: hasAccess(statusAccessMap[opt.value])
	);

	const translatedStatusOptions = allowedStatusOptions.map((option) => ({
		value: option.value,
		label:
			currentLang === "mk"
				? macedonianStatusTranslations[option.value] || option.label
				: option.label,
	}));

	const fetchConfiguration = useCallback(async () => {
		const numberPrefix = await getConfigurationValue(1);
		const countryId = await getConfigurationValue(2);
		setPhonePrefix(numberPrefix);
		setDefaultSystemCountryId(countryId);
	}, []);

	const setOrderDetails = (data: any) => {
		fetchConfiguration();
		setRefId(data?.refId);
		setOrderDescription(data?.orderDescription);
		setPackageDescription(data?.packageDescription);
		setDeliveryInstructions(data?.deliveryInstructions);
		setOpenable(data?.openable);
		setFragile(data?.fragile);
		setDeclared(data?.declared);
		setWidth(data?.width);
		setLength(data?.length);
		setHeight(data?.height);
		setLastValidHeight(data?.height);
		setLastValidLength(data?.length);
		setLastValidWidth(data?.width);
		setLastValidOrderPrice(data?.orderPrice);
		setLastValidTransportPrice(data?.transportPrice);
		setWeight(data?.weight);
		setLastValidWeight(data?.weight);
		setBuyerFirstName(data?.buyerFirstName);
		setBuyerLastName(data?.buyerLastName);
		setBuyerPhoneNo(data?.buyerPhoneNo);
		setInitialBuyerPhoneNo(data?.buyerPhoneNo);
		setBuyerAddressDetails(data?.buyerAddressDetails);
		setSelectedCountry(data?.countryId);
		setSelectedCity(data?.cityId);
		setTransportPrice(data.transportPrice);
		const ordersPriceWithCheck =
			noAccessToInternationalOrderPrice &&
			sellersWithInternationalOrderPrice.includes(data?.sellerId)
				? 0.0
				: data?.orderPrice;
		console.log(
			ordersPriceWithCheck,
			data?.orderPrice,
			"ordersPriceWithCheck"
		);
		// setOderPrice(data.orderPrice);
		setOderPrice(ordersPriceWithCheck);
		setSellerDescription(data.sellerDescription);
		setSectionId(data?.sectionId);
		setRequiresDeliveryCode(data.requiresDeliveryCode);
		if (data?.countryId === 1) {
			setCountryLabel("xk");
		} else if (data?.countryId === 2) {
			setCountryLabel("al");
		} else if (data?.countryId === 3) {
			setCountryLabel("mk");
		}
		let allowEditLocal = false;
		const userRole = getUserRoleFromToken();
		nonEditableStatusIds.includes(data.statusId) ||
		nonEditableStatusIds.includes(data.internationalStatusId) ||
		data.completed === 1 ||
		data.settlementStatus > 0 ||
		!canUpdateDetails
			? (allowEditLocal = false)
			: (allowEditLocal = true);

		if (userRole === userRoles.CLIENT || userRole === userRoles.SUBCLIENT) {
			if (
				nonEditableStatusIdsClient.includes(data.statusId) ||
				data.completed === 1 ||
				data.settlementStatus > 0
			) {
				allowEditLocal = false;
			} else {
				allowEditLocal = true;
			}
		}
		if (userRole !== userRoles.CLIENT && userRole !== userRoles.SUBCLIENT) {
			data.completed === 1 ||
			data.settlementStatus > 0 ||
			nonEditableStatusIds.includes(data.statusId) ||
			!canUpdateDetails
				? setAllowEditSellerDescription(false)
				: setAllowEditSellerDescription(true);
		}
		setAllowEdit(allowEditLocal);
		data.completed === 1 || data.settlementStatus > 0
			? setAllowEditTransportPrice(false)
			: setAllowEditTransportPrice(true);
		let allowedSellers: number[] = [];
		//Hack per me funksionu veq ne ks for now, ne compile per al mk komento
		if (CONFIG?.CURRENCY === "€")
			allowedSellers = [
				591, 593, 596, 1312, 346, 7395, 7388, 7385, 7384, 7383, 183,
				8276, 10814, 10812, 10811, 10808, 10809,
			];

		/*Kerkes e albinit me i leju qeto sellers*/
		data?.statusId === orderStatuses.REGISTERED &&
		!data?.returnable &&
		allowedSellers.includes(data?.sellerId)
			? setAllowOrderPriceEditing(true)
			: setAllowOrderPriceEditing(false);
		setBuyerAddress(data?.buyerAddress);
		// if (autocompleteRef?.current) {
		// 	(autocompleteRef as any).current.setInputText(
		// 		data?.buyerAddress ? data.buyerAddress : ""
		// 	);
		// }
	};

	const getOrderHistory = async () => {
		try {
			const response = await api.get("Order/web-orderHistory", {
				params: {
					orderId: orderId, //!todo fix so that orderid is just 1 and doesnt need to call getorderidbystring
				},
			});
			setOrderHistory(response.data);
		} catch (error) {
			console.log("Error:", error);
		}
	};
	const getSettlementOrderHistory = async () => {
		try {
			const response = await api.get("Order/settlement-orderHistory", {
				params: {
					orderId: orderId,
				},
			});
			setSettlementOrderHistory(response.data);
		} catch (error) {
			console.log("Error:", error);
		}
	};

	const getDeliveryCode = async () => {
		try {
			const response = await api.get(
				"DeliveryCode/select-delivery-code-for-order",
				{
					params: {
						orderId: orderId,
					},
				}
			);
			setDeliveryCode(response.data);
		} catch (error) {
			console.log("Error:", error);
		}
	};

	const getOrderDetails = useCallback(async () => {
		try {
			const response = await api.get("Order/orderdetails", {
				params: {
					id: orderId,
				},
			});
			if (response.status === 200) {
				const data = response.data;
				setOrderDetails(data);
				setOrderDetilsData(data);
			}
		} catch (error) {
			console.error("Error fetching order:", error);
		}
	}, [orderId]);

	const getUsersData = async () => {
		const data = await fetchAllUsers();
		if (data) {
			setAllUsers(data);
		}
		return data;
	};

	const filterAndMapUsers = (users: any) => {
		return users
			?.filter((item: any) => item.userRoleId !== userRoles.CLIENT)
			.map((item: any) => ({
				value: item.id,
				label: `${item.firstName} ${item.lastName} - ${item.userRoleDescription}`,
			}));
	};

	const getAllUsers = useCallback(async () => {
		const users = await getUsersData();
		if (users) {
			const userOptions = filterAndMapUsers(users);
			setUserOptions(userOptions);
		}
	}, []);

	const orderStatusChangeToPreviousStatus = async () => {
		var orderIds = [
			{
				id: String(await getOrderIdFromString(orderId)),
			},
		];
		try {
			const response = await api.post(
				"Order/change-to-previous-status",
				orderIds
			);
			if (response.status === 200) {
				await getOrderDetails();
				await getOrderHistory();
				await getSettlementOrderHistory();
				setOpenChangeStatusToPreviousModal(false);
				toast.success("Statusi u ndryshua me sukses");
			}
		} catch (error) {
			console.log(error);
		}
	};

	const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

	const orderStatusChange = async () => {
		setOnStatusChangeDisabled(true);
		let notAllowedStatusChangesForInternationalOrders = [
			orderStatuses.TRANSPORTING,
			orderStatuses.DELIVERED,
			orderStatuses.REJECTED,
			orderStatuses.PENDING,
			orderStatuses.AWAITING_WITHDRAWL,
			orderStatuses.RETURNED,
			orderStatuses.REDIRECTED,
			orderStatuses.RETURN_STORAGE,
		];
		let notAllowedStatusChangesForReturnOrders = [
			orderStatuses.AWAITING_WITHDRAWL,
			orderStatuses.REJECTED,
			orderStatuses.RETURNED,
			orderStatuses.RETURN_STORAGE,
			//orderStatuses.INTERNATIONAL_TRANSPORTING,
			orderStatuses.REDIRECTED,
		];
		const showError = (message: string) => {
			toast.error(message);
			setOnStatusChangeDisabled(false);
			return false;
		};
		if (
			(userRole === userRoles.SUPPORT ||
				userRole === userRoles.REGIONALMANAGER) &&
			orderDetilsData?.statusId === orderStatuses.DELIVERED
		) {
			return showError(
				"Nuk keni akses per te larguar porosine nga dorezimi!"
			);
		}

		// Check if the order is a return order and if the status change is allowed
		if (orderDetilsData?.returnable) {
			if (selectedStatus === orderStatuses.RETURNED) {
				if (
					userRole !== userRoles.MANAGER &&
					userRole !== userRoles.SUPPORT &&
					userRole !== userRoles.ADMIN
				) {
					return showError(
						"Kjo porosi eshte kthim i parave, dhe nuk mund te ndryshohet statusi ne 'Kthyer'!"
					);
				}
			} else if (
				selectedStatus !== null &&
				notAllowedStatusChangesForReturnOrders.includes(selectedStatus)
			) {
				return showError(
					"Kjo porosi eshte kthim i parave, dhe vetem statusi 'Kthyer' lejohet te ndryshohet nga menaxheri ose supporti!"
				);
			}

			if (orderDetilsData.statusId === orderStatuses.DELIVERED) {
				return showError(
					"Kjo porosi eshte kthim i pageses qe eshte dorezuar, nuk mund te ia ndryshoni statusin"
				);
			}
		}

		// Check if the order is international and if the status change is allowed
		if (
			orderDetilsData?.countryId !== parseInt(defaultSystemCountryId) &&
			selectedStatus !== null &&
			notAllowedStatusChangesForInternationalOrders.includes(
				selectedStatus
			)
		) {
			return showError(
				"Kjo porosi eshte internacionale dhe nuk mund te ia ndryshoni statusin"
			);
		}

		// Check if the international order has the correct status for further steps
		if (
			orderDetilsData?.internationalStatusId !== null &&
			orderDetilsData?.statusId === orderStatuses.REGISTERED
		) {
			if (
				orderDetilsData?.internationalStatusId !==
				orderStatuses.INTERNATIONAL_TRANSPORTING
			) {
				toast.error(
					`Kjo Porosi eshte internacionale dhe nuk eshte ende ${"Në Tranzit"} per tek ju!`
				);
				setOnStatusChangeDisabled(false);
				return;
			}

			if (
				selectedStatus !== null &&
				orderDetilsData?.internationalStatusId ===
					orderStatuses.INTERNATIONAL_TRANSPORTING &&
				selectedStatus !== orderStatuses.IN_STORAGE
			) {
				return showError(
					"Porosia eshte internacionale dhe duhet te pranohet ne depo para se te vazhdoje me hapa te tjere!"
				);
			}
		}

		if (
			orderDetilsData?.internationalStatusId !== null &&
			orderDetilsData?.internationalStatusId ===
				orderStatuses.INTERNATIONAL_TRANSPORTING &&
			selectedStatus !== null &&
			selectedStatus === orderStatuses.PICKED_UP
		) {
			toast.error(
				"Kjo porosi eshte internacionale dhe nuk mund te grumbullohet!"
			);
			setOnStatusChangeDisabled(false);
			return;
		}

		if (
			orderDetilsData?.completed === 1 ||
			orderDetilsData?.settlementStatus > 0
		) {
			toast.error(
				"Kjo porosi eshte e procesuar ne nje barazim, nuk mund te ia ndryshoni statusin"
			);
			setOnStatusChangeDisabled(false);
			return;
		}
		if (orderDetilsData?.statusId === orderStatuses.RETURNED) {
			if (!canReopenReturnedOrderToStorage) {
				toast.error(
					"Nuk mund te ndryshoni statusin e porosisë së kthyer."
				);
				setOnStatusChangeDisabled(false);
				return;
			}
			if (
				selectedStatus === null ||
				orderStatuses.IN_STORAGE !== selectedStatus
				// ![
				// 	orderStatuses.IN_STORAGE,
				// 	orderStatuses.RETURN_STORAGE,
				// ].includes(selectedStatus)
			) {
				toast.error(
					"Porosia e kthyer mund të ndryshohet vetëm në 'Në depo' ose 'Në depon për kthim'."
				);
				setOnStatusChangeDisabled(false);
				return;
			}
		}
		if (
			(selectedStatus === 7 || selectedStatus === 8) &&
			canChangeRefuseOrAwaitOrderStatus
		) {
			const orderParams = {
				orderId: await getOrderIdFromString(orderId),
				statusId: selectedStatus,
				statusChangeComment:
					selectedStatus === 7
						? "Porosia u refuzua nga"
						: "Porosia u vendos ne pritje nga",
				assignFromToUserId: selectedUser,
				transportPrice: orderDetilsData?.transportPrice,
				sellerId: orderDetilsData?.sellerId,
				countryId: orderDetilsData?.countryId,
				displayId: orderDetilsData?.displayId,
				originCountryId: orderDetilsData?.originCountryId,
				uuid: orderDetilsData?.uuid,
				isChatBotOrders: orderDetilsData?.isChatBotOrder,
			};
			try {
				setIsUpdatingStatus(true);
				const response = await api.post(
					"Order/admin-order-await-or-refusal",
					orderParams
				);
				if (response.status === 200) {
					await getOrderHistory();
					await getSettlementOrderHistory();
					statusChangeModalStateClean();
					toast.success("Statusi i porosise u ndryshua me sukses");

					return;
				}
				setOpen(false);
			} catch (error) {
				console.log(error);
			} finally {
				setIsUpdatingStatus(false);
				setOnStatusChangeDisabled(false);
			}

			return;
		}
		const orderParams = {
			orderId: await getOrderIdFromString(orderId),
			statusId: selectedStatus,
			userIdAssign: selectedUser,
			statusChangeComment: "Status Changed from ",
			exchangeable: orderDetilsData?.exchangeable,
			returnable: orderDetilsData?.returnable,
			invoice: orderDetilsData?.invoice,
			orderPrice: orderDetilsData?.orderPrice,
			transportPrice: orderDetilsData?.transportPrice,
			driverPrice: orderDetilsData?.driverPrice,
			countryId: orderDetilsData?.countryId,
			uuid: orderDetilsData?.uuid,
			originCountryId: orderDetilsData?.originCountryId,
			sellerId: orderDetilsData.sellerId,
			displayId: orderDetilsData?.displayId,
		};
		const orderDetailId = [
			{ orderId: await getOrderIdFromString(orderId) },
		];
		try {
			setIsUpdatingStatus(false);
			if (canChangeOrderStatus) {
				const response = await api.put(
					"Order/orderstatuschange",
					orderParams
				);
				if (response.status === 200) {
					await getOrderDetails();
					statusChangeModalStateClean();
					toast.success("Statusi i porosise u ndryshua me sukses!");
				}
			} else if (isClient) {
				const response = await api.post(
					"Order/clientorderstatusupdate",
					orderDetailId
				);
				if (response.status === 200) {
					await getOrderDetails();
					await getDeliveryCode();
					await getOrderHistory();
					await getSettlementOrderHistory();
					setOpen(false);
					toast.success("Statusi i porosise u ndryshua me sukses!");
				}
			} else {
				toast.error("Nuk mund te ndryshoni statusin e porosise");
				return;
			}
			setOpenStatusChangeModal(false);
			await getOrderHistory();
			await getSettlementOrderHistory();
		} catch (error) {
			console.log(error);
			toast.error("Error: " + error);
		} finally {
			setIsUpdatingStatus(false);
			setOnStatusChangeDisabled(false);
		}
	};

	const statusChangeModalStateClean = () => {
		setSelectedStatus(null);
		setSelectedUser(null);
		setOpenStatusChangeModal(false);
	};

	useEffect(() => {
		const userRoleId = getUserRoleFromToken();
		setUserRole(userRoleId);
		userRoleId === userRoles.ADMIN ? setIsAdmin(true) : setIsAdmin(false);
		userRoleId === userRoles.CLIENT || userRoleId === userRoles.SUBCLIENT
			? setIsClient(true)
			: setIsClient(false);
		userRoleId === userRoles.WAREHOUSEMANAGER
			? setWarehouseManager(true)
			: setWarehouseManager(false);
		if (!orderId) {
			navigate("/");
			return;
		}
		const fetchOrderHistory = async () => {
			try {
				const response = await api.get("Order/web-orderHistory", {
					params: {
						orderId: orderId,
					},
				});
				setOrderHistory(response.data);
			} catch (error) {
				console.log("Error:", error);
			}
		};
		getOrderDetails();
		fetchOrderHistory();
		getAllUsers();
		getZones();
		getBuyers();
		getSettlementOrderHistory();
		getDeliveryCode();
	}, [orderId]);

	const [onStatusChangeDisabled, setOnStatusChangeDisabled] =
		useState<boolean>(false);

	const onStatusChange = (value: number) => {
		setSelectedStatus(value);
		setSelectedUser(null);
		const roleMapping: { [key: number]: number[] } = {
			[orderStatuses.TRANSPORTING]: [
				userRoles.DRIVER,
				userRoles.SUPERDRIVER,
			],
			[orderStatuses.DELIVERED]: [
				userRoles.DRIVER,
				userRoles.SUPERDRIVER,
			],
			[orderStatuses.REJECTED]: [userRoles.DRIVER, userRoles.SUPERDRIVER],
			[orderStatuses.PENDING]: [userRoles.DRIVER, userRoles.SUPERDRIVER],
			[orderStatuses.PICKED_UP]: [
				userRoles.COLLECTOR,
				userRoles.SUPERDRIVER,
			],
			[orderStatuses.IN_STORAGE]: [
				userRoles.WAREHOUSEMANAGER,
				userRoles.WAREHOUSE,
			],
			[orderStatuses.INTERNATIONAL_TRANSPORTING]: [
				userRoles.INTERNATIONAL_DRIVER,
			],
		};
		const matchingRoles = Object.keys(roleMapping).find(
			(status) => parseInt(status) === value
		);

		if (matchingRoles) {
			const roles = roleMapping[value];
			const filteredUsers = allUsers
				.filter((item: any) => roles.includes(item.userRoleId))
				.map((item: any) => ({
					value: item.id,
					label: `${item.firstName} ${item.lastName} - ${item.userRoleDescription}`,
				}));
			setUserOptions(filteredUsers);
		} else {
			const users = allUsers
				.filter(
					(item: any) =>
						item.userRoleId !== userRoles.CLIENT &&
						item.userRoleId !== userRoles.SUBCLIENT &&
						item.userRoleId !== userRoles.CHATBOT
				)
				.map((item: any) => ({
					value: item.id,
					label: `${item.firstName} ${item.lastName} - ${item.userRoleDescription}`,
				}));
			setUserOptions(users);
		}
	};

	const onUserChange = (value: number) => {
		setSelectedUser(value);
	};

	const getOrderIdFromString = async (orderId: any) => {
		try {
			const response = await api.get("Order/get-orderid-from-string", {
				params: {
					orderId: orderId,
				},
			});
			return response.data;
		} catch (error: any) {
			console.log("Error:" + error);
			toast.error("Error:" + error.message);
		}
	};
	const hexToRgba = (hex: string, alpha: number) => {
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);
		return `rgba(${r},${g},${b},${alpha})`;
	};

	const statusColorHexCode = orderDetilsData.statusColorCode || "#ffff";
	const rgbaColor = hexToRgba(statusColorHexCode, 0.08);

	const deleteOrder = async () => {
		if (orderDetilsData.statusId > orderStatuses.REGISTERED) {
			toast.error("Kjo porosi nuk mund te fshihet nga sistemi!");
		} else {
			try {
				const response = await api.delete("Order/delete-order", {
					params: {
						orderId: await getOrderIdFromString(orderDetilsData.id),
						countryId: orderDetilsData?.countryId,
						uuid: orderDetilsData?.uuid,
					},
				});
				if (response.status === 200) {
					toast.success("Porosia u fshi me sukses");
					navigate("/order");
				}
			} catch (error: any) {
				console.log("Error:" + error);
				toast.error("Error:" + error.message);
			}
		}
	};

	const getOrDefault = (value: any, defaultValue: any) =>
		!value ? defaultValue : value;

	const [isSavingOrder, setIsSavingOrder] = useState(false);

	const saveOrderChanges = async () => {
		if (
			orderDetilsData?.transportPrice !== transportPrice &&
			(!transportPriceChangeComment ||
				transportPriceChangeComment.trim() === "")
		) {
			toast.error(
				"Ju lutem, shkruani arsyen e ndryshimit të vleres së transportit manualisht."
			);
			setOpenTransportPriceCommentModal(true);
			return;
		}

		const data = {
			orderId: await getOrderIdFromString(orderId),
			refId: refId,
			deliveryInstructions: deliveryInstructions,
			openable: openable,
			fragile: fragile,
			declared: declared,
			buyerFirstName: buyerFirstName,
			buyerLastName: buyerLastName,
			address: buyerAddress,
			addressDetails: buyerAddressDetails,
			buyerPhoneNo: buyerPhoneNo,
			orderDescription: orderDescription,
			packageDescription: packageDescription,
			weight: weight,
			length: length,
			width: width,
			height: height,
			transportPrice: transportPrice,
			orderPrice: orderPrice,
			countryId: orderDetilsData?.countryId,
			changedTransportPrice:
				orderDetilsData?.transportPrice === transportPrice
					? false
					: true,
			changedDimensions:
				orderDetilsData?.width !== parseFloat(width ?? "") ||
				orderDetilsData?.weight !== parseFloat(weight ?? "") ||
				orderDetilsData?.length !== parseFloat(length ?? "") ||
				orderDetilsData?.height !== parseFloat(height ?? "")
					? true
					: false,
			userId: orderDetilsData?.sellerId,
			changedAddress:
				orderDetilsData?.buyerAddress !== buyerAddress ? true : false,
			changedOrderPrice:
				orderDetilsData?.orderPrice !== orderPrice ? true : false,
			sectionId: sectionId,
			sellerDescription: sellerDescription,
			uuid: orderDetilsData?.uuid,
			originCountryId: orderDetilsData?.originCountryId,
			transportPriceChangeComment: transportPriceChangeComment,
			latitude: apiLatitude,
			longitude: apiLongitude,
		};

		if (orderDetilsData?.statusId === orderStatuses.REFUNDED) {
			toast.error(
				"Kjo porosi nuk mund te ndryshohet, porosia eshte shpagim"
			);
			return;
		}
		try {
			setIsSavingOrder(true);
			const response = await api.post("Order/update-order", data);
			if (response.status === 200) {
				await getOrderDetails();
				await getOrderHistory();
				await getSettlementOrderHistory();
				toast.success("Ndryshimet u ruajten me sukses");
				return;
			}
		} catch (error: any) {
			console.log(error);
			toast.error("Error:" + error.message);
		} finally {
			setIsSavingOrder(false);
		}
	};

	const cancelChanges = () => {
		getOrderDetails();
	};

	const printTickets = async () => {
		const ids = [{ Id: orderDetilsData.displayId }];
		const params =
			selectedFormat === "A4"
				? { formatA4: true }
				: selectedFormat === "harleyTicket"
				? { harleyTicket: true }
				: {};
		try {
			const response = await api.post("Order/print-order-ticket", ids, {
				params,
				responseType: "blob",
			});
			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				toast.error(
					"Popup është i bllokuar. Ju lutemi lejoni popup-ët për këtë faqe."
				);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getZones = useCallback(async () => {
		try {
			const allZones = await fetchZones();
			if (allZones) {
				setZones(allZones);
				const countries = allZones
					.filter(
						(country: Zone) =>
							country.id === orderDetilsData?.countryId
					)
					.map((country: Zone) => ({
						value: country.id,
						label: country.description,
					}));
				setCountryOptions(countries);
				const cities = allZones
					.filter(
						(city: Zone) => city.levelId === 2
						// &&
						// 	city.parentId === orderDetilsData?.countryId
					)
					.map((city: Zone) => ({
						value: city.id,
						label: city.description,
					}));
				setCityOptions(cities);
			} else {
				console.error("Failed to fetch zones.");
			}
		} catch (error) {
			console.error("An error occurred while fetching zones:", error);
		}
	}, [selectedCountry]);

	const handleCityOptionsBasedOnCountry = (countryId: any) => {
		const filteredCities = zones
			.filter((item: Zone) => item.parentId === countryId)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityOptions(filteredCities);
	};

	const handleCityChange = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setSelectedCity(id);
			setCityLabel(value?.label);
			setBuyerAddress("");
		} else {
			setSelectedCity("");
			setBuyerAddress("");
		}
	};

	const handleCountryChange = async (countryId: number) => {
		setSelectedCity("");
		setSelectedCountry(countryId);
		setBuyerAddress("");
		switch (countryId) {
			case 1: // Kosovo
				setCountryLabel("xk");
				break;
			case 2: // Albania
				setCountryLabel("al");
				break;
			case 3: // North Macedonia
				setCountryLabel("mk");
				break;
			default:
				break;
		}

		handleCityOptionsBasedOnCountry(countryId);
	};

	const getBuyers = async () => {
		try {
			const response = await api.get("Buyer/select-buyers");
			if (response.status === 200) {
				const result = response?.data;
				setBuyersList(result);
			}
		} catch (error) {
			console.log(error);
		}
	};
	const handleExistingPhoneNumberCancel = () => {
		const selectedBuyer = buyersList?.find(
			(item: any) => item.phone === buyerPhoneNo
		);
		setBuyerPhoneNo(initialBuyerPhoneNo);
		setIsExistingPhoneNumberVisible(false);
	};
	const handleExistingPhoneNumberOk = () => {
		const selectedBuyer = buyersList.find(
			(item: any) => item.phone === buyerPhoneNo
		);
		if (selectedBuyer) {
			setBuyerFirstName(selectedBuyer.firstName);
			setBuyerLastName(selectedBuyer.lastName);
		}
		setIsExistingPhoneNumberVisible(false);
	};

	const handlePhoneNumberBlur = () => {
		const selectedBuyer = buyersList?.find(
			(item: any) => item.phone === buyerPhoneNo
		);
		if (initialBuyerPhoneNo !== buyerPhoneNo && selectedBuyer) {
			setIsExistingPhoneNumberVisible(true);
		}
	};

	const setWeightWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setWeight(lastValidWeight);
		} else {
			setWeight(value);
		}
	};
	const setHeightWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setHeight(lastValidHeight);
		} else {
			setHeight(value);
		}
	};
	const setLengthWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setLength(lastValidLength);
		} else {
			setLength(value);
		}
	};
	const setWidthWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setWidth(lastValidWidth);
		} else {
			setWidth(value);
		}
	};
	const setOrderPriceWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setOderPrice(lastValidOrderPrice);
		} else {
			setOderPrice(value);
		}
	};
	const setTransportPriceWithValidation = (value: string | null) => {
		if (value && value.includes("-")) {
			setTransportPrice(lastValidTransportPrice);
		} else {
			setTransportPrice(value);
		}
	};

	const [data, setData] = useState<SelectProps["options"] | any>([]);

	const handleSearch = (address: any) => {
		if (!selectedCountry || !selectedCity) {
			toast.error("Please select a country and city first");
			setBuyerAddress("");
			return;
		}

		fetchAddresesSearch(
			address +
				" ," +
				(cityLabel && cityLabel?.length > 0 ? cityLabel : "")
		);
	};

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneShofer ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				const section = Number(result.geofences[0]?.name);
				setSectionId(section);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	const fetchAddresesSearch = (address: any) => {
		const params = {
			q: address || "",
			limit: "5",
			lang: "en",
		};
		const queryString = new URLSearchParams(params).toString();
		const requestOptions: RequestInit = {
			method: "GET",
			redirect: "follow",
		};

		fetch(`https://photon.komoot.io/api/?${queryString}`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				const formattedData = result.features.map((feature: any) => ({
					value: feature.properties.osm_id,
					label: feature.properties.name,
					lat: feature.geometry.coordinates[1],
					lon: feature.geometry.coordinates[0],
				}));
				setData(formattedData);
			})
			.catch((err) => console.log("err: ", err));
	};

	let autocompleteRef = useRef<any>();

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setBuyerAddress(selectedLocation.label ?? "");
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
		}
	};

	const fetchSortingMachinePhotos = useCallback(async () => {
		if (!orderId) {
			return;
		}

		try {
			setIsLoadingSortingMachinePhotos(true);
			const response = await api.get<SortingMachinePhoto[]>(
				"Order/select-sorting-machine-photos",
				{
					params: { orderId },
				}
			);
			const photos = response.data ?? [];

			if (!photos.length) {
				setSortingMachinePhotos([]);
				setIsSortingMachineModalOpen(false);
				toast.info(
					strings?.sortingMachinePhotosEmpty ??
						"No sorting machine photos were found for this order."
				);
				return;
			}

			setSortingMachinePhotos(photos);
			setIsSortingMachineModalOpen(true);
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoadingSortingMachinePhotos(false);
		}
	}, [orderId, strings]);

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (
				(event.key === "Enter" || event.code === "NumpadEnter") &&
				!isSavingOrder
			) {
				saveOrderChanges();
			}
		};

		window.addEventListener("keydown", handleKeyDown);

		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [isSavingOrder, saveOrderChanges]);

	const cancleTransportModal = () => {
		setTransportPriceChangeComment("");
		setOpenTransportPriceCommentModal(false);
	};

	const handleTransportPriceCommentOk = () => {
		if (
			!transportPriceChangeComment ||
			transportPriceChangeComment.trim() === ""
		) {
			toast.error(
				"Ju lutem, shkruani arsyen e ndryshimit të çmimit të transportit."
			);
			return;
		}

		saveOrderChanges();
		setOpenTransportPriceCommentModal(false);
		setTransportPriceChangeComment("");
	};

	return (
		<>
			<div className="detailContainer">
				<OrderPriceChangeRequest
					orderId={orderId}
					onButtonsPress={async () => {
						await getOrderDetails();
					}}
				/>

				<div className="firstDetail">
					<div className="titleButton">
						<div className="flex flex-row items-center gap-2">
							<h1 className="font-bold text-[18px]">{`${strings?.title} #${orderDetilsData.displayId}`}</h1>
							{hasAccess("SORTING_MACHINE_PHOTOS_ACCESS") && (
								<Button
									size="large"
									icon={<CameraOutlined />}
									style={{
										color: "#4F16C2",
									}}
									loading={isLoadingSortingMachinePhotos}
									onClick={fetchSortingMachinePhotos}
								>
									{strings?.sortingMachinePhotosButton}
								</Button>
							)}
						</div>
						<div className="flex flex-row flex-wrap justify-center gap-4 ">
							{(canChangeOrderStatus ||
								canReopenReturnedOrderToStorage) &&
							(orderDetilsData?.completed === 0 ||
								orderDetilsData?.settlementStatus === 0) &&
							orderDetilsData?.isInRefund === false &&
							orderDetilsData?.hasDriverSettlement === false &&
							(canReopenReturnedOrderToStorage ||
								orderDetilsData.statusId !==
									orderStatuses.RETURNED) ? (
								<div>
									<Button
										size="large"
										style={{ color: "#4f16c2" }}
										icon={<FormOutlined />}
										onClick={() =>
											setOpenStatusChangeModal(true)
										}
									>
										{strings?.adminButton}
									</Button>
								</div>
							) : orderDetilsData?.statusId ===
									orderStatuses.REGISTERED &&
							  orderDetilsData?.isInRefund === false &&
							  isClient ? (
								<div>
									<Button
										size="large"
										type="primary"
										danger
										icon={<FormOutlined />}
										onClick={() => setOpen(true)}
									>
										{strings?.readyForPickupButton}
									</Button>
								</div>
							) : orderDetilsData?.statusId ===
									orderStatuses.WAITING_PICKUP &&
							  orderDetilsData?.isInRefund === false &&
							  isClient ? (
								<div>
									<Button
										size="large"
										// type="primary"
										// danger
										style={{ color: "#4f16c2" }}
										icon={<FormOutlined />}
										onClick={() =>
											setOpenChangeStatusToPreviousModal(
												true
											)
										}
									>
										{strings?.removewaitingpickup}
									</Button>
								</div>
							) : null}
							{warehouseManager &&
							orderDetilsData?.isInRefund === false &&
							orderDetilsData.statusId !==
								orderStatuses.RETURNED ? (
								<div>
									<Button
										size="large"
										// type="primary"
										// danger
										style={{ color: "#4f16c2" }}
										icon={<FormOutlined />}
										onClick={() =>
											setOpenStatusChangeModal(true)
										}
									>
										{strings?.warehouseManagerButton}
									</Button>
								</div>
							) : null}

							<Button
								size="large"
								style={{
									backgroundColor: "#4F16C2",
									color: "#ffff",
								}}
								icon={<PrinterOutlined />}
								onClick={() => setIsPrintModalOpen(true)}
							>
								{strings?.printTicketButton}
							</Button>
							{orderDetilsData.statusId ===
								orderStatuses.REGISTERED &&
								orderDetilsData?.statusId !==
									orderStatuses.REFUNDED && (
									<Button
										size="large"
										// type="primary"
										style={{
											backgroundColor: "#ffff",
											color: "#FF3B30",
										}}
										// danger
										icon={<DeleteOutlined />}
										onClick={deleteOrder}
									>
										{strings?.deleteOrderButton}
									</Button>
								)}
						</div>
					</div>
				</div>
				<div className="secondDetail">
					<div className="orderDetail">
						<OrderDetailRow
							label={strings?.orderDetails?.title}
							value={""}
							classNameLabel="!text-[#4F16C2] !uppercase"
						/>
						{(orderDetilsData?.completed === 1 ||
							orderDetilsData?.settlementStatus > 0) && (
							<Alert
								message={"Porosia është mbyllur"}
								description={
									"Kjo porosi eshte barazuar me klientin  dhe" +
									" eshte mbyllur per ndryshime ne sistem! "
								}
								type="success"
								showIcon
								style={{
									color: "red",
									// borderColor: " white",
									marginBottom: "8px",
								}}
							/>
						)}
						{orderDetilsData?.isInRefund && (
							<Alert
								message={"Porosia është e perfshire ne shpagim"}
								description={
									"Kjo porosi eshte e perfshire ne shpagim dhe " +
									" eshte mbyllur per ndryshime ne sistem! "
								}
								type="warning"
								showIcon
								style={{
									color: "red",
									// borderColor: " white",
									marginBottom: "8px",
								}}
							/>
						)}
						{orderDetilsData?.hasDriverSettlement && (
							<Alert
								message={"Porosia është e barazuar nga shoferi"}
								description={
									"Kjo porosi eshte e barazuar nga shoferi dhe " +
									" eshte mbyllur per ndryshime te statusit ne sistem! "
								}
								type="warning"
								showIcon
								style={{
									color: "red",
									// borderColor: " white",
									marginBottom: "8px",
								}}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.code}
							value={"#" + orderDetilsData.displayId}
							style={style.oddRow}
						/>
						{orderDetilsData?.createdByUsername && (
							<OrderDetailRow
								label="Krijuar nga useri"
								value={orderDetilsData.createdByUsername}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.refId}
							value={refId}
							inputStyle={style.inputStyle}
							onChangeText={setRefId}
							editable={allowEdit}
						/>
						{requiresDeliveryCode && hasAccessToDeliveryCode && (
							<OrderDetailRow
								label={strings?.orderDetails.deliveryCode}
								value={deliveryCode}
								inputStyle={style.inputStyle}
							/>
						)}
						{hasAccessToIdentificationNo && (
							<OrderDetailRow
								label={
									strings?.orderDetails.identificationNumber
								}
								value={
									orderDetilsData?.buyerIdentificationNumber
								}
								style={style.oddRow}
							/>
						)}
						{!isClient && hasAccessToSellers && (
							<>
								<OrderDetailRow
									label="Shitesi"
									value={
										orderDetilsData?.sellerNameAndSurname
									}
									style={style.oddRow}
								/>
								<OrderDetailRow
									label="Numri i shitesit "
									value={orderDetilsData?.sellerPhoneNo}
								/>
							</>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.status}
							value={
								<div className="statusStyle">
									<div
										className="statusValues"
										style={{
											background: rgbaColor,
											color: statusColorHexCode,
										}}
									>
										<p className="text-lg">&#x2022;</p>
										<p className="w-full">
											{orderDetilsData.status}
										</p>
									</div>
								</div>
							}
							inputStyle={style.inputStyle}
							style={style.oddRow}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.firstName}
							value={buyerFirstName}
							editable={allowEdit}
							onChangeText={setBuyerFirstName}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.lastName}
							value={buyerLastName}
							editable={allowEdit}
							onChangeText={setBuyerLastName}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.country}
							editable={false}
							options={countryOptions}
							value={orderDetilsData?.country}
							style={style.oddRow}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.city}
							editable={allowEdit}
							select={true}
							options={cityOptions}
							value={
								allowEdit ? selectedCity : orderDetilsData?.city
							}
							onChange={handleCityChange}
							labelInValue={true}
						/>
						{/* <OrderDetailRow
							label={strings?.orderDetails.buyer.address}
							value={buyerAddress}
							editable={allowEdit}
							onChangeText={setBuyerAddress}
							style={style.oddRow}
							inputStyle={{ width: "300px" }}
						/> */}
						<div
							className="flex flex-row  items-center min-h-14 p-3"
							style={{
								...style.oddRow,
								display: !allowEdit ? "none" : "flex",
							}}
						>
							<p style={style.label}>
								{strings?.orderDetails.buyer.address}:
							</p>
							{/* <PlaceAutocomplete
								onAddressChange={handleChange}
								country={countryLabel}
								ref={autocompleteRef}
							/> */}
							<AddressSelect
								onAddressChange={handleChange}
								country={countryLabel}
								selectedAddress={buyerAddress}
								city={selectedCity}
							/>
						</div>
						{!allowEdit && (
							<OrderDetailRow
								label={strings?.orderDetails.buyer.address}
								value={buyerAddress}
								options={data}
								style={style.oddRow}
								inputStyle={style.inputStyle}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.buyer.addressDetails}
							value={buyerAddressDetails}
							editable={allowEdit}
							onChangeText={setBuyerAddressDetails}
							style={style.oddRow}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.buyer.phone}
							value={buyerPhoneNo}
							editable={allowEdit}
							onChangeText={setBuyerPhoneNo}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.description}
							value={orderDescription}
							style={style.oddRow}
							editable={allowEdit}
							onChangeText={setOrderDescription}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.packageDescription}
							value={packageDescription}
							editable={allowEdit}
							onChangeText={setPackageDescription}
							inputStyle={style.inputStyle}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.deliveryInstructions}
							value={deliveryInstructions}
							style={style.oddRow}
							editable={allowEdit}
							onChangeText={setDeliveryInstructions}
							inputStyle={style.inputStyle}
						/>
						{allowEditSellerDescription &&
							!isClient &&
							orderDetilsData?.originCountryId !==
								orderDetilsData?.countryId &&
							accessToOrderRealSeller && (
								<OrderDetailRow
									label={
										strings?.orderDetails.sellerDescription
									}
									value={sellerDescription}
									editable={allowEditSellerDescription}
									onChangeText={setSellerDescription}
								/>
							)}
						{accessToOrderDimensions && (
							<OrderDetailRow
								label={strings?.orderDetails.weight}
								value={weight}
								editable={allowEdit && !isClient}
								onChangeText={setWeightWithValidation}
								type="number"
							/>
						)}
						{allowEdit && !isClient && canUpdateOrderDimensions ? (
							<>
								<OrderDetailRow
									label={
										strings?.orderDetails.dimensions.length
									}
									value={length}
									style={style.oddRow}
									editable={allowEdit}
									onChangeText={setLengthWithValidation}
									type="number"
								/>
								<OrderDetailRow
									label={
										strings?.orderDetails.dimensions.width
									}
									value={width}
									editable={allowEdit}
									onChangeText={setWidthWithValidation}
									type="number"
								/>
								<OrderDetailRow
									label={
										strings?.orderDetails.dimensions.height
									}
									value={height}
									style={style.oddRow}
									editable={allowEdit}
									onChangeText={setHeightWithValidation}
									type="number"
								/>
							</>
						) : accessToOrderDimensions ? (
							<OrderDetailRow
								label="Dimensionet(~cm)"
								value={orderDetilsData.dimensions}
								style={style.oddRow}
							/>
						) : (
							<></>
						)}
						<OrderDetailRow
							label={
								strings?.orderDetails.orderPrice +
								CONFIG?.CURRENCY
							}
							value={orderPrice}
							onChangeText={setOrderPriceWithValidation}
							editable={
								(allowOrderPriceEditing && isClient) ||
								(allowEdit &&
									!orderDetilsData?.returnable &&
									!isClient &&
									canChangeOrderValue)
							}
						/>
						{accessToOrderRealPrice && (
							<OrderDetailRow
								label={
									strings?.orderDetails.ordersRealPrice +
									CONFIG?.CURRENCY
								}
								value={orderDetilsData?.ordersRealPrice}
								style={style.oddRow}
							/>
						)}
						{accessToOrderTransportPrice && (
							<OrderDetailRow
								label={
									strings?.orderDetails.transportPrice +
									CONFIG?.CURRENCY
								}
								value={transportPrice}
								onChangeText={setTransportPriceWithValidation}
								editable={
									allowEditTransportPrice &&
									!isClient &&
									canChangeOrderValue
								}
							/>
						)}
						{accessToSaleProfit && (
							<OrderDetailRow
								label={
									strings?.orderDetails.saleProfit +
									CONFIG?.CURRENCY
								}
								value={` ${orderDetilsData.saleProfit}`}
								style={style.oddRow}
							/>
						)}
						<OrderDetailRow
							label={strings?.orderDetails.exchangeable}
							value={orderDetilsData.exchangeableString?.toString()}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.invoice}
							value={orderDetilsData.invoiceString?.toString()}
							style={style.oddRow}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.openable}
							value={orderDetilsData.openableString?.toString()}
							style={style.oddRow}
							bool={true}
							editable={allowEdit}
							checked={openable}
							onCheck={setOpenable}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.fragile}
							value={orderDetilsData.fragileString?.toString()}
							bool={allowEdit}
							editable={allowEdit}
							checked={fragile}
							onCheck={setFragile}
						/>
						<OrderDetailRow
							label={strings?.orderDetails.declared}
							value={orderDetilsData.declaredString?.toString()}
							style={style.oddRow}
							bool={allowEdit}
							editable={allowEdit}
							checked={declared}
							onCheck={setDeclared}
						/>
					</div>
					<div className="orderHistory">
						<div className="pb-4">
							<OrderDetailRow
								label={strings?.orderHistory}
								value={""}
								classNameLabel="!text-[#4F16C2] !uppercase"
							/>
						</div>
						<div className="orderHistoryLines">
							{orderHistory && orderHistory.length > 0 ? (
								orderHistory.map((item, index) => (
									<OrderHistory
										key={index}
										date={item?.statusDate}
										statusChangeComment={
											item?.statusChangeComment ?? " - "
										}
										userName={item?.userName ?? " - "}
										phone={item?.phone ?? " - "}
										statusId={item?.statusId ?? 0}
									/>
								))
							) : (
								<></>
							)}
							{/* {settlementOrderHistory && (
								<> */}
							{accessToSettlementHistory && (
								<>
									{settlementOrderHistory?.map(
										(item, index) => (
											<SettlementOrderHistory
												key={index}
												date={item?.statusDate}
												statusChangeComment={
													item?.statusChangeComment ??
													" - "
												}
												userName={
													item?.userName ?? " - "
												}
												phone={item?.phone ?? " - "}
												statusId={item?.statusId ?? 0}
											/>
										)
									)}
								</>
							)}
							{/* </>
							)} */}
						</div>
					</div>
				</div>
				<div className="buttonat">
					<Buttons
						button1Text={strings?.buttons.cancel}
						onButton1Click={cancelChanges}
						button2Text={strings?.buttons.saveChanges}
						onButton2Click={saveOrderChanges}
						disabled={
							isSavingOrder ||
							(openTransportPriceCommentModal &&
								!transportPriceChangeComment?.trim())
						}
					/>
				</div>
			</div>

			<Modal
				open={openStatusChangeModal}
				title={strings?.modals?.changeStatus?.title}
				onCancel={() => setOpenStatusChangeModal(false)}
				width={1500}
				footer={(_, { OkBtn, CancelBtn }) => (
					<div className="flex items-end justify-end"></div>
				)}
			>
				<Divider />
				<div className="flex flex-row justify-between">
					<div className="w-1/3">
						<p style={style.modalUnderTitles}>
							{strings?.modals.changeStatus.selectedOrders}
						</p>
						<Divider />
						<p style={style.selectedOrder}>
							#{orderDetilsData.displayId}
						</p>
					</div>
					<div className="w-1/3">
						<p style={style.modalUnderTitles}>
							{strings?.modals.changeStatus.setChanges}
						</p>
						<Divider />
						<div className="bg-slate-200 flex flex-col gap-4 p-6">
							<DefaultSelect
								placeholder="- Zgjedhe statusin"
								// width={320}
								options={translatedStatusOptions}
								onChange={onStatusChange}
								value={selectedStatus}
								className="input"
							/>
							<DefaultSelect
								// width={320}
								placeholder="- Zgjedhe pergjegjesin"
								options={userOptions}
								onChange={onUserChange}
								value={selectedUser}
								className="input"
							/>
							<Alert
								type="warning"
								showIcon
								message={"Verejtje"}
								description={
									"Ju lutem qe te keni kujdes gjate perdorimit te ketij moduli." +
									" Ndryshimet do te evidentohen tek te gjitha porosite e zgjedura. "
								}
								style={{
									backgroundColor: "white",
									borderColor: " white",
								}}
							/>
							<Button
								size="large"
								danger
								className="bg-red-100"
								onClick={orderStatusChange}
								icon={<CheckOutlined />}
								style={{
									fontSize: 18,
									fontWeight: 600,
								}}
								disabled={
									isUpdatingStatus || onStatusChangeDisabled
								}
							>
								{strings?.modals?.changeStatus?.saveChanges}
							</Button>
						</div>
					</div>
					<div className="w-1/3 ">
						<p style={style.modalUnderTitles}>
							{strings?.modals?.changeStatus?.info?.title}
						</p>
						<Divider />

						<div className="pl-8">
							<ol
								style={{
									listStyle: "decimal",
									fontSize: 16,
									color: "#1B4965",
								}}
							>
								<li>
									{
										strings?.modals?.changeStatus?.info
											?.items[0]
									}
								</li>
								<li>
									{
										strings?.modals?.changeStatus?.info
											?.items[1]
									}
									<ul
										style={{
											listStyle: "circle",
											paddingLeft: 30,
										}}
									>
										{strings?.modals?.changeStatus?.info?.subItems?.transport.map(
											(subItem: any, index: number) => (
												<li key={index}>{subItem}</li>
											)
										)}
									</ul>
								</li>
								<li>
									{
										strings?.modals?.changeStatus?.info
											?.items[2]
									}
									<ul
										style={{
											listStyle: "circle",
											paddingLeft: 30,
										}}
									>
										{strings?.modals?.changeStatus?.info?.subItems?.warehouse?.map(
											(subItem: any, index: number) => (
												<li key={index}>{subItem}</li>
											)
										)}
									</ul>
								</li>
							</ol>
						</div>
					</div>
				</div>
			</Modal>
			<Modal
				open={open}
				onCancel={() => setOpen(false)}
				onOk={orderStatusChange}
				title={strings?.modals.confirm.title}
				okButtonProps={{
					className: "bg-blue-500",
					disabled: isUpdatingStatus,
				}}
			>
				<p>{strings?.modals.confirm.message}</p>
			</Modal>
			<Modal
				open={openChangeStatusToPreviousModal}
				onCancel={() => setOpenChangeStatusToPreviousModal(false)}
				onOk={orderStatusChangeToPreviousStatus}
				title={strings?.modals.confirm.title}
				okButtonProps={{ className: "bg-blue-500" }}
			>
				<p>{strings?.modals.confirm.registerModalMessage}</p>
			</Modal>
			<Modal
				title={strings?.existingPhoneNumberChangeTitle}
				open={isExistingPhoneNumberVisible}
				onCancel={handleExistingPhoneNumberCancel}
				onOk={handleExistingPhoneNumberOk}
				okButtonProps={{ className: "bg-blue-500" }}
				cancelText={strings?.buttons.cancel}
				okText={strings?.okButtonText}
			>
				<p>{strings?.existingPhoneNumberChangeMessage}</p>
			</Modal>
			<Modal
				title="Zgjidh Formatin e Printimit"
				open={isPrintModalOpen}
				onOk={() => {
					setIsPrintModalOpen(false);
					printTickets();
				}}
				onCancel={() => setIsPrintModalOpen(false)}
				footer={
					<Buttons
						button1Text="Anulo"
						button2Text="Printo"
						onButton1Click={() => setIsPrintModalOpen(false)}
						onButton2Click={printTickets}
					/>
				}
			>
				<Radio.Group
					value={selectedFormat}
					onChange={(e) => setSelectedFormat(e.target.value)}
				>
					<Radio value="100x60">100x60</Radio>

					{hasAccessToA4 && <Radio value="A4">A4</Radio>}
					{hasAccessToHarleyTickets && (
						<Radio value="harleyTicket">Harley tiket</Radio>
					)}
				</Radio.Group>
			</Modal>
			<Modal
				title={"Sheno arsyen e ndryshimit te vleres se Transportit"}
				open={openTransportPriceCommentModal}
				onCancel={cancleTransportModal}
				onOk={handleTransportPriceCommentOk}
				okButtonProps={{ className: "bg-blue-500" }}
				cancelText={strings?.buttons.cancel}
				okText={strings?.okButtonText}
			>
				<DefaultInput
					placeholder={"Shenim"}
					value={transportPriceChangeComment}
					onChange={(e) =>
						setTransportPriceChangeComment(e.target.value)
					}
					allowClear
					// label={""}
					className={style.commentInputStyle}
				/>
			</Modal>

			<Modal
				open={isSortingMachineModalOpen}
				title={strings?.sortingMachinePhotosModalTitle}
				onCancel={() => setIsSortingMachineModalOpen(false)}
				footer={null}
				width={900}
			>
				<div className="grid gap-6 md:grid-cols-2">
					{sortingMachinePhotos.map((photo) => {
						const sizeInKb =
							typeof photo.sizeBytes === "number"
								? (photo.sizeBytes / 1024).toFixed(2)
								: null;

						return (
							<div
								key={photo.objectKey}
								className="flex flex-col gap-2"
							>
								<img
									src={`data:image/png;base64,${photo.base64Data}`}
									alt={`sorting-machine-${photo.objectKey}`}
									className="max-h-96 w-full rounded bg-slate-100 object-contain"
								/>
								<div className="text-sm text-gray-600">
									<p>{photo.objectKey}</p>
									<p>
										Camera ID: {photo.cameraId} · Size:{" "}
										{sizeInKb ? `${sizeInKb} KB` : "-"}
									</p>
								</div>
							</div>
						);
					})}
				</div>
			</Modal>
		</>
	);
};

export default OrderDetails;
const style = {
	oddRow: { backgroundColor: "#f7f8fa" },
	modalUnderTitles: {
		fontSize: 18,
		color: "#1B4965",
	},
	//fix width
	selectedOrder: {
		backgroundColor: "#5FA8D3",
		fontSize: 18,
		color: "white",
		width: "fit-content",
		borderRadius: 4,
	},
	inputStyle: {
		width: "100%",
	},
	commentInputStyle: {
		width: "100%",
	},
	container: {
		// backgroundColor: "#fff",
		// padding: 8,
		// paddingLeft: 6,
		// borderBottom: "1px solid #eee",
		// gap: "16px",
		height: "40px",
		width: "8.8rem",
	},
	label: {
		fontSize: 14,
		fontWeight: "bold",
		color: "#2C2C2C",
		fontFamily: "Inter",
		width: "50%",
	},
	value: {
		width: "50%",
		fontFamily: "Inter",
		color: "#2C2C2C",
		fontSize: 14,
		fontWeight: 400,
		display: "flex",
		justifyContent: "flex-start",
	},
	editableContainer: {
		width: "50%",
		display: "flex",
		justifyContent: "flex-start",
	},
	textInput: {
		backgroundColor: "#fff",
		height: "40px",
		width: "10rem",
	},
	textContainer: {
		outline: "none",
		width: "9rem",
	},
	switch: {
		width: "50%",
		display: "flex",
		justifyContent: "flex-start",
	},
};
